import { render, staticRenderFns } from "./textContent.vue?vue&type=template&id=95a1b2c8&scoped=true&"
import script from "./textContent.vue?vue&type=script&lang=js&"
export * from "./textContent.vue?vue&type=script&lang=js&"
import style0 from "./textContent.vue?vue&type=style&index=0&id=95a1b2c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a1b2c8",
  null
  
)

export default component.exports